
import { Component } from 'vue-property-decorator';
import 'firebase/firebase-firestore';
import LogsList, { LogFields } from './LogsList.vue';

@Component
export default class NivLogs extends LogsList {
  public getTitle(): string {
    return 'NIV logs';
  }

  public getSpecificFields(): LogFields {
    return {
      respWard: {
        label: 'Resp Ward/HDU/ITU'
      },
      cpapBipap: {
        label: 'CPAP/BIPAP'
      }
    };
  }

  protected getCollectionName(): string {
    return 'niv-logs';
  }
}
